import { Swiper, Navigation, EffectFade, Thumbs } from 'swiper'

Swiper.use([Navigation, EffectFade, Thumbs])

const $slider = document.querySelector('.story-page-slider')
const $thumbSlider = document.querySelector('.story-page-thumb-slider')

const fn = {
  init: () => {
    if ($slider.querySelectorAll('.swiper-slide').length < 2) {
      return
    }

    let thumbSlider = null

    if ($thumbSlider) {
      thumbSlider = new Swiper(
        $thumbSlider.querySelector('.swiper-container'),
        {
          spaceBetween: 10,
          slidesPerView: 3,
          loop: true,
          loopedSlides: $thumbSlider.querySelectorAll('.swiper-slide').length,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          allowTouchMove: false,
        }
      )
    }

    const sliderOpts = {
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      loopedSlides: $slider.querySelectorAll('.swiper-slide').length,
    }

    if (thumbSlider) {
      sliderOpts.thumbs = {
        swiper: thumbSlider,
      }
    }

    const slider = new Swiper(
      $slider.querySelector('.swiper-container'),
      sliderOpts
    )

    const $mediaPrev = $thumbSlider.querySelector('.slider-prev')
    const $mediaNext = $thumbSlider.querySelector('.slider-next')

    if ($mediaPrev) {
      $mediaPrev.addEventListener('click', () => {
        slider.slidePrev()
      })
    }

    if ($mediaNext) {
      $mediaNext.addEventListener('click', () => {
        slider.slideNext()
      })
    }
  },
}

export default {
  can: () => $slider,
  run: fn.init,
}
